import { show, swal, close } from './actions';
import { selectSweetAlert } from './selectors';
import SweetAlert from './SweetAlert';
import './sweet-alert.scss';
export default SweetAlert;

export { show, swal, close, selectSweetAlert };
